export interface SubMenuItem {
  title: string;
  href: string;
  isBold?: boolean;
  isHiddenOnMobile?: boolean;
  isDirectOnMobile?: boolean;
  group?: string | null;
  noHover?: boolean;
}
export interface HeaderMenuItem {
  title: string;
  desc: string;
  href: string;
  src: string;
  subMenu: Record<string, SubMenuItem[]>;
}
export const headerMenu: HeaderMenuItem[] = [
  {
    title: "gnb.product",
    desc: "menu.products.desc",
    href: "/all-products",
    src: "/main/header/super-high-1030x634.jpg",
    subMenu: {
      bodyComposition: [
        { title: "menu.products.body-composition-analyzers", href: "/products/0", isBold: true },
        { title: "products.inbody970", href: "/product/inbody970", isHiddenOnMobile: true },
        { title: "products.inbody770", href: "/product/inbody770", isHiddenOnMobile: true },
        { title: "products.inbody580", href: "/product/inbody580", isHiddenOnMobile: true },
        { title: "products.inbody380", href: "/product/inbody380", isHiddenOnMobile: true },
        { title: "products.inbody270", href: "/product/inbody270", isHiddenOnMobile: true },
      ],
      bodyWater: [
        { title: "menu.products.body-water-analyzers", href: "/products/1", isBold: true },
        { title: "products.bwa2.0", href: "/product/bwa2-0", isHiddenOnMobile: true },
        { title: "products.inbodys10", href: "/product/inbody-s10", isHiddenOnMobile: true },
        { title: "menu.products.blood-pressure-monitor", href: "/products/2", isBold: true },
        { title: "products.bpbio750", href: "/product/bpbio750", isHiddenOnMobile: true },
        { title: "products.bpbio320", href: "/product/bpbio320", isHiddenOnMobile: true },
      ],
      other: [
        { title: "menu.products.stadiometer", href: "/products/3", isBold: true },
        { title: "products.bsm370", href: "/product/bsm370", isHiddenOnMobile: true },
        { title: "products.bsm170", href: "/product/bsm170", isHiddenOnMobile: true },
        { title: "menu.products.handgrip-strength-dynamometer", href: "/products/4", isBold: true },
        { title: "products.ingrip", href: "/product/ingrip", isHiddenOnMobile: true },
        {
          title: "menu.products.lookingbody-web",
          href: "/product/lookinbody-web/",
          isBold: true,
          isDirectOnMobile: true,
        },
      ],
    },
  },
  {
    title: "gnb.support",
    desc: "menu.support.desc",
    href: "#",
    src: "/main/header/Guiding-Principles-2.png",
    subMenu: {
      contact: [
        { title: "menu.support.contact-us", href: "/contact/contact-us", isDirectOnMobile: true },
        { title: "menu.support.locate-us", href: "#", isDirectOnMobile: true },
      ],
      support: [
        { title: "menu.support", href: "#", isBold: true, isDirectOnMobile: true, noHover: true },
        { title: "menu.support.download-centre", href: "/support/download-centre", isDirectOnMobile: true },
        { title: "menu.support.data-integration", href: "/support/data-integration", isDirectOnMobile: true },
        { title: "menu.support.tech-support", href: "/support/support-request", isDirectOnMobile: true },
      ],
    },
  },
  {
    title: "gnb.learn",
    desc: "menu.learn.desc",
    href: "#",
    src: "/main/header/malaysia.png",
    subMenu: {
      learning: [
        { title: "menu.learn.about-us", href: "/learn/about-us", isBold: true, isDirectOnMobile: true },
        { title: "menu.learn.technology", href: "#", isBold: true, isDirectOnMobile: true, noHover: true },
        {
          title: "menu.learn.what-is-body-composition",
          href: "/learn/what-is-body-composition",
          isDirectOnMobile: true,
        },
        { title: "menu.learn.inbody-technology", href: "/learn/inbody-technology", isDirectOnMobile: true },
        { title: "menu.learn.inbody-in-studies", href: "/learn/inbody-in-studies", isDirectOnMobile: true },
        { title: "menu.learn.inbody-test-procedures", href: "/learn/inbody-test-procedures", isDirectOnMobile: true },
      ],
      resultInterpretation: [
        { title: "menu.learn.result-interpretation", href: "#", isBold: true, isDirectOnMobile: true, noHover: true },
        {
          title: "menu.learn.body-composition-result-sheet",
          href: "/learn/body-composition-result-sheet",
          isDirectOnMobile: true,
        },
        { title: "menu.learn.body-water-result-sheet", href: "/learn/body-water-result-sheet", isDirectOnMobile: true },
        { title: "menu.learn.eval-result-sheet", href: "/learn/evaluation-result-sheet", isDirectOnMobile: true },
        { title: "menu.learn.children-result-sheet", href: "/learn/children-result-sheet", isDirectOnMobile: true },
      ],
      application: [
        { title: "menu.learn.application", href: "#", isBold: true, isDirectOnMobile: true, noHover: true },
        { title: "menu.learn.medical", href: "/learn/medical", isDirectOnMobile: true },
        { title: "menu.learn.fitness", href: "/learn/fitness", isDirectOnMobile: true },
        { title: "menu.learn.pharmacy", href: "/learn/pharmacy", isDirectOnMobile: true },
        { title: "menu.learn.aesthetic", href: "/learn/aesthetic", isDirectOnMobile: true },
        { title: "menu.learn.corporate", href: "/learn/corporate", isDirectOnMobile: true },
        { title: "menu.learn.blogs", href: "/learn/blog", isBold: true, isDirectOnMobile: true },
      ],
    },
  },
];

export interface footerMenuItem {
  title: string;
  items: {
    label: string;
    href: string;
    visible?: boolean;
  }[];
}
export const footerMenu: footerMenuItem[] = [
  {
    title: "menu.support",
    items: [
      { label: "menu.support.download-centre", href: "/support/download-centre" },
      { label: "menu.support.data-integration", href: "/support/data-integration" },
      { label: "menu.support.tech-support", href: "/support/support-request" },
    ],
  },
  {
    title: "menu.products",
    items: [
      { label: "menu.products.body-composition-analyzers", href: "/learn/blog", visible: false },
      { label: "menu.products.lookingbody-web", href: "/product/lookinbody-web" },
    ],
  },
  {
    title: "gnb.learn",
    items: [
      { label: "menu.learn.about-us", href: "/learn/about-us/" },
      { label: "menu.learn.latest-news", href: "/learn/blog", visible: false },
      { label: "menu.learn.what-is-body-composition", href: "/learn/what-is-body-composition/" },
      { label: "menu.learn.inbody-technology", href: "/learn/inbody-technology/" },
    ],
  },
];
